export default __webpack_public_path__ + "static/media/bluediamond2.78d54976.jpg";